import { TabView, TabViewPanel } from '@myosh/odin-components';
import React, { useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import SimpleSearch from './simple-search.component';
import LazyLoadedPage from '../../components/layout/routes/lazy-loaded-page.component';
import { useParams } from 'react-router';

interface AdministrationPageSettings {
  id: number;
  positionInTab: number;
  label: string;
  component: React.JSX.Element;
}

export default function GloablSearchPage() {
  const [pages, setPages] = useState<React.JSX.Element[]>();
  const { t } = useTranslation();
  const { searchValue } = useParams();

  const administrationPageSettings: AdministrationPageSettings[] = useMemo(
    () => [
      {
        id: 0,
        positionInTab: 0,
        label: `"${searchValue}" ${t('from-all-data')}`,
        component: <LazyLoadedPage page={<SimpleSearch searchValue={searchValue} />} />,
      },
    ],
    [searchValue, t]
  );

  useEffect(() => {
    const pages: React.JSX.Element[] = [];

    for (let i = 0; i < administrationPageSettings.length; i++) {
      const { id, label, component } = administrationPageSettings[i];

      pages.push(
        <TabViewPanel key={id} header={label}>
          {component}
        </TabViewPanel>
      );
    }
    setPages(pages);
  }, [administrationPageSettings]);

  return <div className="flex h-full w-full flex-col pb-5">{pages && <TabView>{pages}</TabView>}</div>;
}
